<template>
  <span>
    <span v-if="min && max">
      {{ min | roundedNumber }} - {{ max | roundedNumber }}
    </span>
    <span v-if="min && !max"> at least {{ min | roundedNumber }} </span>
    <span v-if="!min && max"> up to {{ max | roundedNumber }} </span>
    <span v-if="!min && !max">-</span>
  </span>
</template>

<script>
import { roundedNumber } from '@/filters'

export default {
  filters: { roundedNumber },
  props: {
    min: Number,
    max: Number,
  },
}
</script>
